import resources from "../data/Resources.json";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import "../styles/Mat-container.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const Material = () => {
  const [articleData, setArticles] = useState({ resources: [] });
  const [error, setError] = useState(null);
  const handleDownload = async (title) => {
    try {
      const response = await fetch(`/Articles/${title}`);
      if (!response.ok) {
        throw new Error("File not found");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = title; // Must be a string, like "example.pdf"
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("PDF download failed. Please check the file name or path.");
    }
  };

  useEffect(() => {
    try {
      setArticles(resources);
      //  setLoading(false);
    } catch (err) {
      console.error("Error loading JSON:", err);
      setError("Failed to load center data. Please try again later.");
      //setLoading(false);
    }
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!articleData) return <p>Loading...</p>;

  return (
    <div className="Mat-container">
      <div className="protocols">
        <h2 className="condition-h3">
          Below You Can Read and Download Important Scientific Papers About NIV
        </h2>
        {articleData.resources.map((group, index) => (
          <div key={index}>
            {/* Display the condition name */}
            <h2 className="condition-title">{group.condition}</h2>

            {/* Display the articles under this condition */}
            {group.articles.map((article, i) => (
              <div className="mat-links" key={i}>
                <a
                  href={`/Articles/${article.link}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "darkblue",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {article.title}
                </a>

                <button
                  onClick={() => handleDownload(article.link)}
                  className="download-but"
                >
                  <FontAwesomeIcon
                    icon={faDownload}
                    style={{ fontSize: "16px" }}
                  />
                </button>
              </div>
            ))}
          </div>
        ))}

        <div className="mat-pro">
          <h4>Other(non-Bach) NIV References & Resources</h4>
          <p>
            Many people have been told by their physicians that they need
            "non-Bach" published articles and information related to noninvasive
            ventilation (NIV) and other issues addressed on this site. Of
            course, each of Dr. Bach's articles include many references to other
            authors' published works; however, in an attempt to address this
            need, we will build this page with links to abstracts or full text
            of other published works.
          </p>
        </div>
        <div className="mat-pro">
          <h4>Supplemental O2 and Hypercapnia</h4>

          <p>
            Oxygen is NOT for Hypoventilation in Neuromuscular Disease. E.A.
            Oppenheimer, MD, FCCP{" "}
            <Link
              to="http://www.gbppa.org/oxygen.htm"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              IVUN News, Spring, 2000, Vol. 14, No. 1 (Full Text)
            </Link>
          </p>
          <p>
            Severe hypercapnia after low-flow oxygen therapy in patients with
            neuromuscular disease and diaphragmatic dysfunction. Gay PC, Edmonds
            LC.{" "}
            <Link
              to="https://pubmed.ncbi.nlm.nih.gov/7898136/"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              Mayo Clin Proc 1995 Apr;70(4):327-30 (Abstract)
            </Link>
          </p>
        </div>

        <div className="mat-pro">
          <h4>Duchenne Muscular Dystrophy</h4>

          <p>
            People with Duchenne muscular dystrophy need to follow the{" "}
            <Link
              to="/resources/op"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              Outpatient Protocol
            </Link>{" "}
            to avoid any breathing difficulties from Duchenne muscular
            dystrophy. With the proper attention, hospitalization can usually be
            avoided and tracheostomy is never necessary. No one needs to suffer
            and die from respiratory complications of Duchenne muscular
            dystrophy any longer.
          </p>
        </div>
        <div className="mat-pro">
          <h4>Amyotrophic Lateral Sclerosis</h4>
          <p>
            People with amyotrophic lateral sclerosis (ALS) usually have either
            primarily skeletal muscle ALS where the arms and legs become weak
            along with the breathing and coughing muscles, or "bulbar" ALS where
            the throat muscles become weak causing loss of speech and
            swallowing. People with the former type often develop colds that
            cause airway secretions that they cannot effectively cough out. This
            causes pneumonia and respiratory failure. At this point they are
            hospitalized and told that they need tracheostomy tubes. However,
            with the use of inspiratory and expiratory muscle aids this is
            always avoidable.
          </p>
          <p>
            We have removed the tracheostomy tubes of ventilator users with ALS
            and switched them to using safer and more comfortable inspiratory
            muscle aids. Since we cannot assist throat muscles the way we can
            the inspiratory and coughing muscles, we can do less for bulbar ALS
            patients. However, the cough machine can at times be effective to
            prevent pneumonia and respiratory failure.
          </p>
          <p>
            For patients with tracheostomy tubes, the cough machine can also be
            used through the tube to eliminate the need to suction through the
            tube. Exsufflation through a tube is much less uncomfortable than
            suctioning.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Material;
